import type React from "react";
import { type ReactNode, createContext, useContext, useRef } from "react";
import type { LoadingBarRef } from "react-top-loading-bar";

interface LoadingBarContextType {
	startLoading: () => void;
	completeLoading: () => void;
}

const LoadingBarContext = createContext<LoadingBarContextType | undefined>(undefined);

interface LoadingBarProviderProps {
	children: ReactNode;
}

export const LoadingBarProvider: React.FC<LoadingBarProviderProps> = ({ children }) => {
	const ref = useRef<LoadingBarRef>(null);

	const startLoading = () => {
		ref.current?.continuousStart();
	};

	const completeLoading = () => {
		ref.current?.complete();
	};

	return (
		<LoadingBarContext.Provider value={{ startLoading, completeLoading }}>
			{/*<LoadingBar color="#2980b9" ref={ref} />*/}
			{children}
		</LoadingBarContext.Provider>
	);
};

export const useLoadingBar = (): LoadingBarContextType => {
	const context = useContext(LoadingBarContext);
	if (!context) {
		throw new Error("useLoadingBar must be used within a LoadingBarProvider");
	}
	return context;
};
